import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin, Card } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import StockForm from './stockForm';
import Loader from '../../../../components/loader/loader';



const OpeningStock = (props) => {

  const { api, userData, mainCurrency, accounttData, warehouseData, companyId, yearId, refData, contentLanguages } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;
  const createdBy = parseInt(userData.id);
  const today = new Date().toISOString().split('T')[0];

  const { } = props;
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [validated, setValidated] = useState(false);
  const [idRow, setIdRow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [warehouse, setWarehouse] = useState([]);


  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['warehouse']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  // WareHouse Options
  const warehouseOptions = warehouseData?.map(item => ({
    id: item.id,
    value: item.id,
    label: item.name,
  }))


  const openModal = (e) => {
    if(!warehouse?.id){
      toast.error('please select warehouse');
      return;
    }
    setShowModal(!showModal);
  }

  useEffect(() => {
    if (warehouse?.id) {
      getOpeningStock();
    }
  }, [warehouse]);

  const getOpeningStock = async () => {
    try {
      setIsLoading(true);
      const data = {
        companyId,
        yearId,
        warehouseId: warehouse.id,
      }
      let res = await api.get(`journalVoucher/getOpeningStock`, { params: data });

      if (res.data.status) {
        setIdRow(res?.data?.data)
      } else {
        toast.error(res?.data?.status);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>



      <Card style={{ textAlign: 'center', width: '600px' }}>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <div>
            <Row>
              <p>
                {contentLanguages.OpeningStockDescription}
              </p>
            </Row>

            <Row className='mb-4'>
              <Col md={3}>
              </Col>
              <Col md={6}>
                <Select
                  options={warehouseOptions}
                  isSearchable={true}
                  placeholder="Select Warehouse"
                  onChange={setWarehouse}
                  value={warehouse}
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col md={4}>
              </Col>
              <Col md={4}>
                <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={openModal}>View JV</Button>
              </Col>
            </Row>
          </div>
        }
      </Card>


      <StockForm
        showModal={showModal}
        toggleModal={openModal}
        idRow={idRow}
        getOpeningStock={getOpeningStock}
        warehouse={warehouse}
      />



    </div >
  )
}


export default OpeningStock;